import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { API as AWS_API, Auth } from 'aws-amplify';
import { ValidationService } from 'src/app/core/services/validation.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ConsumerForgotPasswordComponent } from '../consumer-forgot-password/consumer-forgot-password.component';
import { StorageService } from 'src/app/core/services/storage.service';
import { ConsumerVerificationCodeComponent } from '../consumer-verification-code/consumer-verification-code.component';
import { TicketPurchasedConfirmDialog } from '../consumer-verification-code/ticket-purchased-confirm.component';
import { AWS_RES_STATUS_CODE, CONST_AWS_API, API } from 'src/app/core/constants';
import { environment } from 'src/environments/environment';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CommanSubscribeService } from 'src/app/core/services/comman-subscribe.service';
import { AppService } from 'src/app/core/services/app.service';
import { Subscription } from 'rxjs';
import { GlobalPubnubService } from 'src/app/core/services/global-pubnub.service';
import { GroupPreferenceService } from 'src/app/core/services/group-preference.service';
import { getGroupSegment, hasGroupSegment } from 'src/app/core/utils/group-url.util';
const EMAIL_REGEX = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
declare var UserAgent: any;
@Component({
  selector: 'app-consumer-sign-in',
  templateUrl: './consumer-sign-in.component.html',
  styleUrls: ['./consumer-sign-in.component.scss']
})
export class ConsumerSignInComponent implements OnInit {
  signInForm: FormGroup;
  returnUrl: any = "";
  url: any;
  communityItem: any;
  getEventData: any;
  liveEventInfo: any;
  // streamInfo:any;
  // streamInfoSubscription:Subscription;
  isSubscribed: any;
  skipRedirection: any;
  subEvents: any;
  user_subscription_info: any;
  skipIcRedirection: any;
  deviceType: string;
  deviceData: Subscription;
  performerInfoSubscription!: Subscription;
  organizationId: number = 0;
  // When true, hides the dialog's own close (X) button and the Forgot Password link — disableClose
  // on the MatDialog config only blocks backdrop-click/Escape, not these in-template escape routes,
  // so a caller that needs the fan to actually sign in (e.g. the "create an account" flow during
  // ticket checkout) must also suppress them, or the fan can dismiss the dialog (or hop into the
  // forgot-password dialog and abandon the flow from there) and continue as a guest anyway.
  forceSignIn: boolean = false;
  signInRouteData: {
    redirectData: any,
    returnUrl: any,
    lastRouteInSignIn: any
    getEventData?: any,
    skipRedirection?: any,
    skipIcRedirection?: any

  };

  constructor(private _matDialog: MatDialog, private _formBuilder: FormBuilder,
    private matDialogRef: MatDialogRef<ConsumerSignInComponent>, private storageService: StorageService,
    public router: Router, private toastr: ToastrService, private ngxLoader: NgxUiLoaderService,
    private commanSubscribeService: CommanSubscribeService, private appService: AppService,
    private activeRoute: ActivatedRoute, @Inject(MAT_DIALOG_DATA) private data: any,private globalPubnubService:GlobalPubnubService,
    private groupPreferenceService: GroupPreferenceService) {
    this.url = data.url;
    this.communityItem = data.communityItem;
    this.forceSignIn = !!data.forceSignIn;
    console.log(this.communityItem, "this.communityItem in constructor");
    let returnUrl = this.activeRoute.snapshot.queryParams.returnUrl || this.commanSubscribeService.returnUrl;
    this.returnUrl = returnUrl ? returnUrl : this.url;
    this.signInRouteData = {
      redirectData: data,
      returnUrl: this.returnUrl,
      lastRouteInSignIn: this.router.url
    };
    this.storageService.setItem('signInRouteData', this.signInRouteData);
  }


  settingsData: any = {};
  channelUrl: any;
  userInfo: any;
  guestInfoSubscr: any;
  guestInfo: any; s
  code: string = '';

  async ngOnInit() {
    this.userInfo = this.commanSubscribeService.userInfo;
    this.deviceType = this.commanSubscribeService.deviceType;
    this.deviceType = this.deviceType.toLowerCase()
    //console.log(this.deviceType)
    this.guestInfoSubscr = this.commanSubscribeService.getGuestInfo().subscribe(response => {
      this.guestInfo = response;
    });

    this.deviceData = this.commanSubscribeService.getAppType().subscribe(response => {
      this.deviceType = response?.toLowerCase();
    });

    this.channelUrl = this.storageService.getItem('channelName');
    if (!this.channelUrl) {
      const nonChannelSlugs = ['userhome', 'signup', 'communities', 'privacypolicy', 'cookiepolicy', 'termsandconditions', 'contactus', 'network-market', 'auth'];
      const segments = this.router.url.split('?')[0].split('/').filter(Boolean);
      if (segments.length > 0 && !nonChannelSlugs.includes(segments[0])) {
        this.channelUrl = segments[0];
      }
    }
    this.settingsData = this.commanSubscribeService.icWebpageSettingsData;
    if (!this.router.url.includes(this.channelUrl)) {
      this.settingsData = {};
    }

    this.getEventData = this.storageService.getItem('eventInfo');
    this.skipRedirection = this.storageService.getItem('skipRedirection');
    this.skipIcRedirection = this.storageService.getItem('skipIcRedirection');

    this.signInRouteData = { ...this.signInRouteData, getEventData: this.getEventData, skipRedirection: this.skipRedirection, skipIcRedirection: this.skipIcRedirection };

    this.storageService.deleteItem('socialRedirection');
    // this.commonSubscribeService.streamInfo = this.streamInfo;
    // this.streamInfoSubscription = this.commanSubscribeService.getStreamInfo().subscribe(response => {
    //   this.streamInfo = response;
    // });
    // this.getEventData = this.getEventData ? this.getEventData : this.streamInfo;  
    this.buildForm();
    this.isSubscribed = this.storageService.getItem('isSubscribed');

    const initialPerformerInfo = this.commanSubscribeService.perfomerInfoData;
    if (initialPerformerInfo?.data?.Data?.[0]?.organization_id) {
      this.organizationId = initialPerformerInfo.data.Data[0].organization_id;
    }
    this.performerInfoSubscription = this.commanSubscribeService.getPerfomerInfo().subscribe(response => {
      if (response?.data?.Data?.[0]?.organization_id) {
        this.organizationId = response.data.Data[0].organization_id;
      }
    });

  }





  buildForm() {
    let email = this.storageService.getItem('signInEmail') || (this.userInfo && this.userInfo.email && !this.guestInfo) ? this.userInfo.email : "";
    let value: any = '';
    if (email) {
      value = { value: email, disabled: this.guestInfo ? false : true }
    }

    this.signInForm = this._formBuilder.group({
      email: [value, [Validators.required, ValidationService.emailValidator, Validators.pattern(EMAIL_REGEX)]],
      password: ['', Validators.required]
    });
  }

  consumerSignIn() {
    if (this.signInForm.valid) {
      let data: any = this.signInForm.getRawValue();
      data.email = data.email.toLowerCase();
      this.ngxLoader.start();
      Auth.signIn({
        username: data.email,
        password: data.password,
        validationData: null,
      }).then(user => {
        this.ngxLoader.stop();
        if (user && user.signInUserSession && user.signInUserSession.accessToken &&
          user.signInUserSession.accessToken.jwtToken) {
          let myInit = {
            headers: {},
            response: true,
            body: {
              email: data.email
            }
          }
          this.ngxLoader.start();
          AWS_API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.GET_USER, myInit).then(response => {
            this.ngxLoader.stop();
            let userInfo = response.data.user;
            userInfo.signedIn = true;
            console.log("userInfo.custom_attributes.role",userInfo.custom_attributes.role);

            // userInfo.access_token = user.signInUserSession.accessToken.jwtToken;
            userInfo.access_token = userInfo.session_token;
            // this.storageService.setItem("user_Info", userInfo);
            localStorage.isFanLoginUser = true;
            localStorage.setItem("isLoggedIn", "true");
            this.commanSubscribeService.sendUserInfo(userInfo, this.organizationId);
            if (this.getEventData) {
              if (this.getEventData.isEvent == 'channels') {
                this.router.navigateByUrl(`/c/${this.getEventData.channel_name}/profile`)
              } else if (this.getEventData.isEvent == 'vod') {
                this.router.navigateByUrl(`/watch/${this.getEventData.id}`)
              } else if (this.getEventData.isEvent == 'live' || this.getEventData.isEvent == 'upcoming') {
                // if (this.getEventData.number_of_creators > 1) {
                //   this.router.navigateByUrl(`/group-stream/${this.getEventData.id}`);
                //           } else {
                this.router.navigateByUrl(`${this.router.url.split("/")[1]}/stream/${this.getEventData.id}`);
                //           }
              }
            } else {
              if (!this.returnUrl) {
                this.router.navigateByUrl(this.router.url);
              } else {
                if (this.router.url.includes('stream')) {
                  this.router.navigate([this.returnUrl]).then(() => {
                    setTimeout(() => {
                      window.location.reload();
                    }, 500);
                  });
                } else {
                  this.commanSubscribeService.returnUrl = "";
                  this.router.navigate([this.returnUrl]);
                }
              }
            }

            this.matDialogRef.close("");
          }).catch(error => {
            this.ngxLoader.stop();
          });
        }
      }).catch(err => {
        this.ngxLoader.stop();
        console.error("User Sign Form Cognito", err);
        if (err && err.code && err.code == AWS_RES_STATUS_CODE.USER_NOT_CONFIRMED_EXCEPTION) {
          this.toastr.error(err.message);
          this.matDialogRef.close("");
          this.openVerificationCode({});
        } else if (err && err.message) {
          this.toastr.error(err.message);
        }
      });
    }
  }
  closeModal() {
    this.matDialogRef.close();
    this.storageService.deleteItem('isSubscribed');
    this.storageService.deleteItem('skipRedirection');
    this.storageService.deleteItem('skipIcRedirection');
  }
  openVerificationCode(data) {

    let formdata: any = data;
    data.email = data.email ? data.email.toLowerCase() : "";
    formdata.email = this.signInForm.getRawValue().email;
    formdata.email = formdata.email ? formdata.email.toLowerCase() : "";

    this.matDialogRef.close("");
    // console.log(this.settingsData)
    const dialogRef = this._matDialog.open(ConsumerVerificationCodeComponent, {
      maxWidth: "320px",
      panelClass: Object.keys(this.settingsData).length > 0 && this.settingsData.form_bg_color ? "app-consumer-cverification-code" : "app-consumer-verification-code",
      // Same reasoning as forceSignIn on the sign-in dialog: when this OTP step was reached via
      // the mandatory create-account/sign-in flow, dismissing it (this dialog has no close
      // button of its own, so backdrop-click/Escape were the only way) let the fan continue as
      // a guest without ever verifying the account that was just created for them.
      disableClose: this.forceSignIn,
      data: {
        formdata: formdata,
        request_from: "login"
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == "yes") {
      }
    });
  }


  //this is going to onelogin portal




  private ONELOGIN_DOMAIN = `${environment.OIDC.onelogin_account_name}.onelogin.com`;
  private CLIENT_ID = environment.OIDC.client_id;
  // private TEST_REDIRECT_URI = 'http://localhost:4200/auth/callback';
  private APPLE_REDIRECT_URI = `${environment.social_auth_redirect_uri}auth/apple/callback`;
  private GOOGLE_REDIRECT_URI = `${environment.social_auth_redirect_uri}auth/google/callback`;
  private SCOPE = 'openid profile email';
  private RESPONSE_TYPE = 'code';
  private TRUSTED_IDP_ISSUER = 'https://accounts.google.com';
  private APPLE_TRUSTED_IDP_ISSUER = 'https://appleid.apple.com';

  loginWithApple() {
    localStorage.setItem('redirectUrlAfterGoogleLogin', this.router.url);
    const initiateUrl =
      `https://${this.ONELOGIN_DOMAIN}/access/initiate` +
      `?iss=${encodeURIComponent(this.APPLE_TRUSTED_IDP_ISSUER)}` +
      `&response_type=${this.RESPONSE_TYPE}` +
      `&scope=${encodeURIComponent(this.SCOPE)}` +
      `&target_link_uri=${encodeURIComponent(this.APPLE_REDIRECT_URI)}`;
    console.log("initiateUrl Apple :: ", initiateUrl);
    window.location.href = initiateUrl;
  }



  // //WORKED BUT REDIRECTED WITH ACCESS ERROR
  loginWithGoogle() {

    localStorage.setItem('redirectUrlAfterGoogleLogin', this.router.url);
    const initiateUrl =
      `https://${this.ONELOGIN_DOMAIN}/access/initiate` +
      `?iss=${encodeURIComponent(this.TRUSTED_IDP_ISSUER)}` +
      `&response_type=${this.RESPONSE_TYPE}` +
      `&scope=${encodeURIComponent(this.SCOPE)}` +
      `&target_link_uri=${encodeURIComponent(this.GOOGLE_REDIRECT_URI)}`;
      console.log("initiateUrl Google :: ", initiateUrl);
      window.location.href = initiateUrl;      
    }
    //  Example:   `https://${this.ONELOGIN_DOMAIN}/access/initiate?iss=appleid.apple.com&response_type=code&scope=openid%20profile%20email&target_link_uri=https%3A%2F%2Fdev.bigbee.ai%2Fauth%2Fcallback`;


  // loginWithOneLogin() {
  //   const oidcUrl =
  //     `https://${this.ONELOGIN_DOMAIN}/oidc/2/auth` +
  //     `?client_id=${encodeURIComponent(this.CLIENT_ID)}` +
  //     `&redirect_uri=${encodeURIComponent(this.REDIRECT_URI)}` +
  //     `&response_type=${this.RESPONSE_TYPE}` +
  //     `&scope=${encodeURIComponent(this.SCOPE)}`;

  //   window.location.href = oidcUrl;
  // }

  consumerOpenSignUp() {
    this.matDialogRef.close("signup");
    this.storageService.deleteItem('skipRedirection');
    this.storageService.setItem('eventInfo', this.getEventData);

    const pathOnly = this.router.url.split('?')[0];
    const channel = pathOnly.split('/')[1] || this.channelUrl;
    // Preserve the group segment (if any) so signup lands on /:channelName/:groupName/sign-up
    // instead of dropping to the org-level /:channelName/sign-up - otherwise ChannelWebpageGuard
    // never resolves :groupName and the fan's group never gets attributed to their signup.
    const groupSegment = getGroupSegment(pathOnly);
    const groupSuffix = groupSegment ? '/' + groupSegment : '';
    if (Object.keys(this.settingsData).length > 0) {
      this.router.navigate(['/' + pathOnly.split('/')[1] + groupSuffix + '/sign-up'])
    } else if (channel) {
      this.router.navigateByUrl('/' + channel + groupSuffix + '/sign-up');
    } else {
      this.router.navigateByUrl("signup");
    }
  }

  openForgotPassword() {
    this.matDialogRef.close("");
    const dialogRef = this._matDialog.open(ConsumerForgotPasswordComponent, {
      maxWidth: "350px",
      panelClass: Object.keys(this.settingsData).length > 0 && this.settingsData.form_bg_color ? "app-forgot-cpassword" : "app-forgot-password",
      disableClose: true,
      data: {}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == "yes") {
        this.matDialogRef.close("");
      }
    });
  }


  OpenSign() {
    // if (!localStorage.userInfo) {
    this.storageService.setItem("portalChange", { requestFrom: 'login' });
    // }
    window.location.href = environment.VENDOR_PORTAL;
  }



  signInFromOneLogin() {
    if (this.signInForm.valid) {

      let data: any = this.signInForm.getRawValue();
      data.email = data.email.toLowerCase();
      let reqData = {
        email: data.email,
        password: data.password,
        login_for: this.activeRoute.snapshot && this.activeRoute.snapshot.queryParams && this.activeRoute.snapshot.queryParams.device ? "payment":undefined,
        organization_id: this.organizationId || 0
      }
      this.ngxLoader.start();

      this.appService.postRequest(API.FAN_LOGIN, reqData).subscribe(result => {
        this.ngxLoader.stop();
        if (result && result.status == 0) {
          this.globalPubnubService.init();
          this.globalPubnubService.subscribeToChannels(result?.user?.id);
          const orgEntry = result.user.organizations?.find((o: any) => o.organization_id == this.organizationId);
          const isVerified = orgEntry?.is_verified;
          if (!isVerified || isVerified == 0) {
            this.openVerificationCode(result.user);
            this.toastr.success("Please verify user.");
          } else if (isVerified == 1) {
            let userInfo = result.user;
            userInfo.signedIn = true;
            userInfo.access_token = userInfo.session_token;
            userInfo.is_profile_completed = true;
            let isAffiliateUser = userInfo.referral_code ? true : false;
            this.storageService.setItem("isAffiliateUser", isAffiliateUser);
            this.storageService.setItem("user_Info", { access_token: userInfo.access_token });
            this.storageService.setItem("affiliateReferralCode", userInfo?.referral_code);
            this.storageService.setItem("role",userInfo.custom_attributes.roles);
            this.commanSubscribeService.sendUserInfo(userInfo, this.organizationId);
            localStorage.isFanLoginUser = true;
            this.commanSubscribeService.updateFanLoginStatus(true)
            this.storageService.deleteItem('eventInfo');
            this.storageService.deleteItem('isSubscribed');
            this.storageService.deleteItem('skipRedirection');
            this.storageService.deleteItem('skipIcRedirection');
            if (this.router.url.includes(this.channelUrl)) {
              this.commanSubscribeService.trackGoogleAnalytics('login');
              this.commanSubscribeService.trackFBEvents('Login');
              // this.commanSubscribeService.setTriggerAiAgent(true);
            }
            if(this.router.url.split("/").length - 1 === this.channelUrl){
              this.commanSubscribeService.setTriggerAiAgent(true);
            }
            if (this.skipRedirection == 'yes') {
              // Signing in mid-checkout (e.g. account creation prompted while buying a ticket) -
              // stay on the checkout page UNLESS this account already holds a ticket for this
              // event, in which case confirm with the buyer before leaving the checkout page.
              if (this.getEventData && this.getEventData.id) {
                let ids = {
                  "stream_id": this.getEventData.id,
                  "userid": userInfo.id,
                }
                let ticketCheckData = {
                  headers: {
                    "Content-Type": "application/json",
                    "x-api-key": environment.AWS_Cognito.X_Api_Key,
                    "Authorization": `Bearer ${userInfo.access_token}`
                  },
                  response: true,
                  body: ids
                }
                this.ngxLoader.start();
                AWS_API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.GET_LIVE_EVENT_BY_ID, ticketCheckData).then(ticketResponse => {
                  this.ngxLoader.stop();
                  const existingTickets = ticketResponse?.data?.Data?.user_subscription_info;
                  if (ticketResponse.data.statusCode === '200' && existingTickets && existingTickets.length > 0) {
                    // Close the sign-in dialog first so the confirmation prompt isn't stacked
                    // on top of it.
                    this.matDialogRef.close("success");
                    const dialogRef = this._matDialog.open(TicketPurchasedConfirmDialog, {
                      panelClass: 'app-signout-confirmation',
                      disableClose: true,
                      data: { settingsData: this.settingsData }
                    });
                    dialogRef.afterClosed().subscribe(result => {
                      if (result == 'no') {
                        this.commanSubscribeService.sendScreenStatus(false);
                        this.router.navigateByUrl(`${this.commanSubscribeService.getBasePathFromUrl(this.router.url)}/event/schedule/${existingTickets[0].ticket_key}`);
                      }
                    });
                  } else {
                    this.matDialogRef.close("success");
                  }
                }).catch(() => {
                  this.ngxLoader.stop();
                  this.matDialogRef.close("success");
                });
              } else {
                this.matDialogRef.close("success");
              }
            } else {

              // ADD THIS: Handle community navigation FIRST (before other navigation logic)
              if ((this.router.url.includes('communities') && this.communityItem && this.communityItem.channel_name)) {
                console.log("Navigating to community:", this.communityItem.channel_name);
                this.router.navigateByUrl(`/${this.communityItem.channel_name}/community`);
                this.matDialogRef.close("success");
                return; // Important: Exit early to prevent other navigation
              }

              if((this.communityItem?.path ==='community' && this.communityItem.channel_name)) {
                console.log("Navigating to community:", this.communityItem.channel_name);
                if(this.returnUrl)
                this.router.navigateByUrl(this.returnUrl)
                else
                this.router.navigateByUrl(`/${this.communityItem.channel_name}/community`)
                
                this.matDialogRef.close("success");
                return; // Important: Exit early to prevent other navigation
              }
              
              // Rest of your existing navigation logic remains unchanged...
              if (this.returnUrl && this.returnUrl.includes('/subscription-list')) {
                let returnUrls = this.returnUrl.split("?returnUrl=");
                if (returnUrls.length == 2) {
                  this.router.navigate([this.returnUrl]);
                  this.router.navigate([returnUrls[0]], { queryParams: { returnUrl: returnUrls[1] } });
                } else {
                  this.router.navigate([this.returnUrl]);
                }
                this.matDialogRef.close("");
                return;
              }
              // For subscribing channels with referral code
              if (this.router.url && this.router.url.includes('/subscription-list')) {
                let returnUrls = this.router.url.split("?ref=");
                if (returnUrls.length == 2) {
                  this.router.navigate([returnUrls[0]], { queryParams: { ref: returnUrls[1] } });
                } else {
                  this.router.navigate([this.router.url]);
                }
                this.matDialogRef.close("");
                return;
              }


              if (this.getEventData && Object.keys(this.getEventData).length > 0) {
                if (this.getEventData.isEvent == 'channels') {
                  this.router.navigateByUrl(`/c/${this.getEventData.channel_name}/profile`)
                } else if (this.getEventData.isEvent == 'live' || this.getEventData.isEvent == 'upcoming' || this.getEventData.isEvent == 'vod') {
                  let ids;
                  ids = {
                    "stream_id": this.getEventData.id,
                    "userid": userInfo.id,
                  }
                  let data = {
                    headers: {
                      "Content-Type": "application/json",
                      "x-api-key": environment.AWS_Cognito.X_Api_Key,
                      "Authorization": `Bearer ${userInfo.access_token}`
                    },
                    response: true,
                    body: ids
                  }
                  this.ngxLoader.start();
                  AWS_API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.GET_LIVE_EVENT_BY_ID, data).then(response => {
                    this.ngxLoader.stop();
                    if (response.data.statusCode === '200') {
                      this.liveEventInfo = response['data']['Data'];
                      this.subEvents = this.liveEventInfo['subEvents'];
                      this.user_subscription_info = this.liveEventInfo['user_subscription_info'];
                      this.commanSubscribeService.sendLoginStatus(true);
                      if ((this.getEventData.isEvent == 'vod' || this.liveEventInfo.stream_status == 'completed') && this.getEventData.slug != null && this.liveEventInfo.user_subscription_info && this.liveEventInfo.user_subscription_info.length == 0 && this.getEventData.allow_vod) {
                        if (this.getEventData.ref_code != '')
                          this.router.navigate([`${this.commanSubscribeService.getBasePathFromUrl(this.router.url)}/event/` + this.getEventData.slug + '/place-order'], { queryParams: { ref: this.getEventData.ref_code } });
                        else
                          this.router.navigateByUrl(`${this.commanSubscribeService.getBasePathFromUrl(this.router.url)}/event/${this.getEventData.slug}/place-order`);
                      } else if (this.getEventData.allow_vod && this.liveEventInfo.user_subscription_info && this.liveEventInfo.user_subscription_info.length > 0) {
                        this.router.navigateByUrl(`watch/${this.getEventData.id}`);
                      } else if (!this.getEventData.allow_vod) {
                        this.toastr.error('Video recording is not available');
                      }
                      if ((this.getEventData.isEvent == 'upcoming' || this.getEventData.isEvent == 'live') && this.liveEventInfo && this.liveEventInfo.stream_status != 'completed') {
                        if (this.liveEventInfo && this.liveEventInfo.user_subscription_info && this.liveEventInfo.user_subscription_info.length == 0) {
                          if (!this.getEventData.message) {
                            if (this.getEventData.ref_code != '')
                              this.router.navigate([`${this.commanSubscribeService.getBasePathFromUrl(this.router.url)}/event/` + this.getEventData.slug + '/place-order'], { queryParams: { ref: this.getEventData.ref_code } });
                            else
                              this.router.navigateByUrl(`${this.commanSubscribeService.getBasePathFromUrl(this.router.url)}/event/${this.getEventData.slug}/place-order`);
                          } else {
                            this.router.navigateByUrl(`${this.commanSubscribeService.getBasePathFromUrl(this.router.url)}/event/${this.getEventData.slug}`);
                          }
                        } else {
                          this.commanSubscribeService.sendScreenStatus(false);
                          this.router.navigateByUrl(`${this.commanSubscribeService.getBasePathFromUrl(this.router.url)}/event/schedule/${this.user_subscription_info[0].ticket_key}`);
                          // this.router.navigateByUrl(`/stream/${this.getEventData.id}`);
                        }
                      }
                    }
                  }).catch(error => {
                    this.ngxLoader.stop();
                  });
                }
              } else {
                //console.log('testreturnurl', this.returnUrl);
                if (!this.returnUrl) {
                  if (!this.skipIcRedirection) {
                    // Plain login (no group already in the URL) - try redirecting to the fan's
                    // preferred group instead of just staying put; falls back to today's
                    // behavior if there's no saved preference, a stale one, or the call fails.
                    if (!hasGroupSegment(this.router.url) && this.channelUrl) {
                      const currentUrl = this.router.url;
                      const groups = this.commanSubscribeService.perfomerInfoData?.data?.Data?.[0]?.groups || [];
                      this.groupPreferenceService
                        .resolveLoginRedirectSlug(userInfo?.id, this.organizationId, this.channelUrl, groups)
                        .subscribe((groupSlug) => {
                          if (groupSlug) {
                            this.router.navigateByUrl(`/${this.channelUrl}/${groupSlug}`);
                          } else {
                            this.router.navigateByUrl(currentUrl);
                          }
                        });
                    } else {
                      this.router.navigateByUrl(this.router.url);
                    }
                  } else {
                    this.router.navigate([this.skipIcRedirection]).then(() => {
                      setTimeout(() => {
                        window.location.reload();
                      }, 500);
                    });
                  }
                } else {
                  if (this.router.url.includes('stream')) {
                    this.router.navigate([this.returnUrl]).then(() => {
                      setTimeout(() => {
                        window.location.reload();
                      }, 500);
                    });
                  } else if (this.returnUrl)
                    this.router.navigate([this.returnUrl]);
                  else
                    this.router.navigateByUrl(this.router.url);
                }
              }
              this.matDialogRef.close("success");
            }

            const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
            (window as any).umami?.track(`Sign-In Successfully by - ${userId}`)
            const payload = {
              actionType: "sign-in",
              metaData: {
                title: `Sign-In Successfully`,
                timeStamp: new Date().toISOString()
              },
              organizationId: this.commanSubscribeService?.slugInfo?.organization_id || null,
            }
            this.commanSubscribeService.sendTriggeredEvent(payload);
          }
        } else {
          this.toastr.error(result.message);
          this.ngxLoader.stop();
        }
      }, error => {
        this.ngxLoader.stop();
      });
    }

  }

  OL_signInSocial(type) {

    this.storageService.deleteItem('skipRedirection');
    this.storageService.setItem("socialRedirection", this.router.url);

    if (this.router.url.includes('/event/') && !this.router.url.includes('event/schedule'))
      this.storageService.setItem("isSocialLogin", true);
    if (this.isSubscribed) {
      this.storageService.setItem("subscriptionChannelName", this.isSubscribed);
      this.storageService.deleteItem('isSubscribed');
    }
    if (typeof (UserAgent) !== "undefined") {
      UserAgent.set("Mozilla/5.0 (Linux;)");
    }
    if (type == "google") {
      window.location.href = environment.oneLogin.googleCallBack;
    } else if (type == "faceBook") {
      window.location.href = environment.oneLogin.faceBookCallBack;
    } else if (type == "linkedin") {
      window.location.href = environment.oneLogin.linkedinCallBack;
    }
  }

  ngOnDestroy() {
    if(this.guestInfoSubscr) {
      this.guestInfoSubscr.unsubscribe();
    }
    if (this.performerInfoSubscription) {
      this.performerInfoSubscription.unsubscribe();
    }
    //   if (this.streamInfoSubscription)
    //     this.streamInfoSubscription.unsubscribe();
  }

}
